import normalizeEntity from '@flow/libs/normalized-redux/entity-normalizer';

const normalizedAccountGroups = normalizeEntity({
  entity: 'accountGroup',
});

export default normalizedAccountGroups;
